import React from 'react';
import PaymentMethods from './components/PaymentMethods';
import PaymentProvider from './PaymentProvider';

const PaymentModal = ({ data = {}, callback }) => {
  return (
    <div className="custom-modal-wrapper">
      <PaymentProvider modalData={{ ...data, callback }}>
        <PaymentMethods />
      </PaymentProvider>
    </div>
  );
};

export default PaymentModal;
